import { Component, Input, Output, EventEmitter, TemplateRef, SimpleChanges } from '@angular/core';
import { ValuationRatios } from '../pharma-page.model';
import { PharmaDataService } from '../pharma-data.service';

@Component({
  selector: 'app-pharma-valuation-filter',
  templateUrl: './pharma-valuation-filter.component.html',
  styleUrls: ['./pharma-valuation-filter.component.scss']
})
export class PharmaValuationFilterComponent {
  @Input() loading: boolean;
  @Input() activePanel = "";
  @Input() refreshCurrentPanel = false;
  @Input() panel = {} as any;
  @Input() data: ValuationRatios;
  @Input() filter ={} as any;
  @Input() amountFormatter: TemplateRef<any>;
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  selected_year: string;
  selected_ratio: string;
  selected_min: number;
  selected_max: number;
  minValue: number;
  maxValue: number;

  customSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };

  constructor(private dataService: PharmaDataService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && this.data && this.filter) {
      if (!this.selected_year || !this.selected_ratio) {
        if (!this.selected_year && this.data?.default_year) {
          this.selected_year = this.filter.selected_year || this.data.default_year;
        }
        if (!this.selected_ratio && this.data?.default_ratio) {
          this.selected_ratio = this.filter.selected_ratio || this.data.default_ratio;
        }
      }
      this.changeMinMax();
    }
  }

  onValueChange(obj) {
    let payload = {
      ...this.filter,
      selected_min: obj.min,
      selected_max: obj.max,
      selected_ratio: this.selected_ratio,
      selected_year: this.selected_year
    };
    this.onChange.emit(payload);
  }
  // onYearChange(year) {
  //   let payload = {...this.filter, selected_year: year };
  //   this.onChange.emit(payload);
  // }
  onDropdownChange(ratio) {
    this.changeMinMax();
    // this.dataService.getValuationRatioFacetGraphData({
    //   selected_ratio: this.selected_ratio,
    //   selected_year: this.selected_year,
    // }).subscribe((resp) => {
    //   this.data.ratio = resp?.data?.ratio;
    //   this.data.no_of_companies = resp?.data?.no_of_companies;
    //   this.data.min = resp?.data?.min;
    //   this.data.max = resp?.data?.max;
    //   this.selected_min = resp?.data?.min;
    //   this.selected_max = resp?.data?.max;
    //   // let payload = {
    //   //   ...this.filter,
    //   //   selected_min: this.selected_min,
    //   //   selected_max: this.selected_max,
    //   //   selected_ratio: this.selected_ratio,
    //   //   selected_year: this.selected_year
    //   // };
    //   // this.onChange.emit(payload);
    // })
  }

  changeMinMax() {
    this.selected_min = this.data.min_max_combinations[this.selected_ratio][this.selected_year]['min_value'];
    this.selected_max = this.data.min_max_combinations[this.selected_ratio][this.selected_year]['max_value'];
    this.minValue = this.selected_min;
    this.maxValue = this.selected_max;
    // this.selected_min = this.filter.selected_min || this.data.min;
    // this.selected_max = this.filter.selected_max || this.data.max;
  }
}
